module.exports = __webpack_public_path__ + "img/ainews2.a9d5ec45.png";